<template>
  <ion-page v-touch:swipe.right="onSwipeRight" v-touch:swipe.left="onSwipeLeft">
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title>Teetime</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-header  :translucent="true" class="paddingtop" >
      <ion-list>
        <ion-item v-if="selectedTeetime" lines="full" class="itemFlight">
          <ion-button v-if="isPlatform('mobile') && !allOpen" class="buttonNoPadding" fill="clear" slot="start" @click="openAll(true)" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="chevronDownOutline" :ios="chevronDownOutline"></ion-icon>
          </ion-button>
          <ion-button v-if="isPlatform('mobile') && allOpen" class="buttonNoPadding" fill="clear" slot="start" @click="openAll(false)" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="chevronUpOutline" :ios="chevronUpOutline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" class="buttonNoPadding" slot="start" @click="openCourseHelp()" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="helpCircleOutline" :ios="helpCircleOutline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" class="buttonNoPadding" slot="start" @click="showDayView = !showDayView" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="cameraReverseOutline" :ios="cameraReverseOutline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" class="buttonNoPadding" slot="start" @click="refresh()" >
           <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="refreshOutline" :ios="refreshOutline"></ion-icon>
          </ion-button>
          <ion-select class="small-select" v-if="selectedTeetime?.selection?.length && selectedSelection" interface="action-sheet" slot="end" :value="selectedSelection.courseid"  @ionChange="itemChanged($event.target.value)">
            <ion-select-option v-for="(item, index) in selectedTeetime.selection" :key="index" :value="item.courseid">{{ item.name }}</ion-select-option>          
          </ion-select>
        </ion-item>
        <ion-item lines="full" v-if="$route.params.id">
          <ion-button :title="$t('today')" class="buttonNoPadding" fill="clear" slot="start" @click="goDateToday()" >
            <ion-icon color="primary" :md="todayOutline" :ios="todayOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
          <ion-button class="buttonNoPadding" fill="clear" slot="start" @click="goDateBack()" >
            <ion-icon :md="arrowBackOutline" :ios="arrowBackOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
          <ion-datetime class="small-datetime"
            :min="`${(new Date()).getFullYear()-1}-01-01`"
            :max="`${(new Date()).getFullYear()+1}-12-31`"
            slot="start"
            :value="selectedDate"
            @ionChange="
              ev => {
                const raw = ev.detail.value;
                if (!raw) return;
                const picked = dayjs(raw).format('YYYY-MM-DD');
                if (picked !== $route.params.date) {
                  forceSpinner = true;
                  getSelectedCourseIDRefetch({ date: picked })
                    .then(res => {
                      const courseID = res.data.getSelectedCourseID.courseID == 0
                        ? $route.params.id
                        : res.data.getSelectedCourseID.courseID;
                      $router.push('/teetime/' + courseID + '/' + picked);
                      selectedDate = picked;
                    })
                    .catch(() => {
                      $router.push('/teetime/' + $route.params.id + '/' + picked);
                      selectedDate = picked;
                    });
                }
              }
            "
            :day-short-names="customDayShortNames"
            display-format="DDD, DD MMM YY"
            placeholder="Select Date">
          </ion-datetime>
          <ion-button class="buttonNoPadding" fill="clear" slot="start" @click="goDateForward()" >
          <ion-icon :md="arrowForwardOutline" :ios="arrowForwardOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
          <ion-select class="small-select" interface="popover" slot="end" @ionChange="setFreeSpots()" v-model="selectedNewSlots">
            <ion-select-option value="0">{{ $t('all')}}</ion-select-option>
            <ion-select-option value="1">{{ $t('min1')}}</ion-select-option>
            <ion-select-option value="2">{{ $t('min2')}}</ion-select-option>
            <ion-select-option value="3">{{ $t('min3')}}</ion-select-option>
            <ion-select-option value="4">{{ $t('min4')}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item v-if="showAddText && (selectedTeetime && (selectedTeetime.dayComment != '' || selectedTeetime.additionalText != '' || selectedTeetime.sunset != ''))">
          <ion-icon style="font-size: 20px;" @click="closeDialog(false)" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
        <ion-grid class="ion-no-padding">
          <ion-row class="ion-no-padding small-daycomment-row">
            <span v-html="$t('sunsetInfo') + ': ' + selectedTeetime.sunset" class="ion-no-padding ion-no-margin small-daycomment" style="margin-left: 20px; white-space: pre-wrap; color: orange;" v-if="selectedTeetime && selectedTeetime.sunset != ''"></span>
          </ion-row>
          <ion-row class="ion-no-padding small-daycomment-row">
            <span v-html="selectedTeetime.dayComment" class="small-daycomment" style="margin-left: 20px; white-space: pre-wrap;" v-if="selectedTeetime && selectedTeetime.dayComment != ''"></span>
          </ion-row>
          <ion-row class="small-daycomment-row">
            <span class="ion-no-padding ion-no-margin small-daycomment" v-if="selectedTeetime && selectedTeetime.additionalText != ''" v-html="selectedTeetime.additionalText" ></span>
          </ion-row>
        </ion-grid>
        </ion-item>
<!--          <ion-item lines="none" class="compact-toggle">
            <ion-label>{{ $t('Tagesansicht') }}</ion-label>
            <ion-toggle v-model="showDayView" color="primary" class="tiny-toggle"></ion-toggle>
          </ion-item>-->
      </ion-list>

    </ion-header>

    <ion-content :fullscreen="true" ref="content">
      <ion-refresher v-if="isPlatform('mobile')" slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
        <h3 v-if="!selectedTeetime && !findTeetimeCourseLoading">{{ $t('noTeetimeCourseFound') }}</h3>
        <ion-grid v-if="!showDayView && selectedTeetime && selectedDate" style="z-index: 999; !important" >
          <ion-row>
            <ion-col v-for="(slot, index) in selectedTeetime.slots" :key="index" size="4" size-xl="4" size-lg="6" size-md="6" size-sm="12" size-xs="12">
              <ion-card :id="(slot.currentSlot ? 'currentSlot' : '')">
                <ion-card-header>
                    <ion-item lines="full" :color="slot.isTeetimeLocked ? 'warning' : ''"  @click="slot.isLocked || !isPlatform('mobile') ? slot.showPlayers : slot.showPlayers = !slot.showPlayers">
                      <ion-icon v-if="isPlatform('mobile') && !slot.isLocked && slot.showPlayers == false" style="zoom: 1.0" slot="start" color="primary" :md="chevronDownOutline" :ios="chevronDownOutline"></ion-icon>
                      <ion-icon v-if="isPlatform('mobile') && !slot.isLocked && slot.showPlayers == true" style="zoom: 1.0" slot="start" color="primary" :md="chevronUpOutline" :ios="chevronUpOutline"></ion-icon>
                      <h3 :style="'color: ' + (slot.isPast ? '' : slot.timeColor) + ';'" slot="start">{{ dayjs(slot.date).tz().format('HH:mm') }}</h3>
                      <h4 v-if="selectedTeetime.greenfeePaymentEnabled || selectedTeetime.showGreenfeePrice" slot="end">{{ getPrice(slot) }} </h4>
                    </ion-item>
                </ion-card-header>
                <ion-card-content overflow-scroll="true" class="has-header" v-if="!slot.isLocked">
                   <ion-list style="padding:0;" v-if="isLoggedIn && !slot.isTeetimeLocked && (slot.showBookingIcon || (!slot.showBookingIcon && !slot.userAllowedToBook && slot.bookingPersons.find(f => f.isMyBooking))) && !slot.isLocked && slot.price >= 0 && !slot.isPast && selectedTeetime.maxPersonsBookable > (slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length)">
                    <ion-item lines="none" class="itemFlight">
                      <ion-select slot="start" v-model="selectedFlight" interface="popover" class="ion-no-margin ion-no-padding" >
                        <ion-select-option v-for="(flight, index) in flights" :key="index" :value="flight.id">
                          {{ $t(flight.name) }}
                        </ion-select-option>
                      </ion-select>
                      <ion-button v-if="((selectedTeetime && !selectedTeetime.greenfeePaymentEnabled) || slot.price == 0) && slot.userAllowedToBook" @click="doBooking(slot)" slot="start" style="margin-left: 5px;" class="ion-no-margin ion-no-padding" fill="clear">
                        <ion-icon style="zoom: 1.5; vertical-align: middle;" color="success" :md="downloadOutline" :ios="downloadOutline"></ion-icon>
                      </ion-button>
                      <ion-button @click="editBooking(slot)" style="margin-left: 10px;" slot="start" class="ion-no-margin ion-no-padding" fill="clear">
                        <ion-icon style="zoom: 1.4; vertical-align: middle;" color="primary" :md="colorWandOutline" :ios="colorWandOutline"></ion-icon>
                      </ion-button>
                      <ion-button v-if="!slot.isPast && slot.carts.filter(f => f.isAvailable).length > 0" @click="editBooking(slot)"  slot="end" fill="clear">
                        <ion-icon style="zoom: 1.4; vertical-align: middle;" color="success" slot="end" :md="carOutline" :ios="carOutline"></ion-icon>
                      </ion-button>
                    </ion-item>
                  </ion-list>
                  <ion-list>
                  <div v-if="slot.showPlayers">
                    <ion-item v-for="(n, i) in selectedTeetime.maxPersonsBookable" :key="i" :color="getBookingColor(slot, i)">

                      <ion-icon v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].withCart" :md="carOutline" :ios="carOutline" style="zoom: 0.9" color="dangerlight"></ion-icon>
                      <ion-avatar @contextmenu.prevent="" :class="imgClass" @click="changeImg()" v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].avatarLink != '' && slot.bookingPersons[i].showAvatar">
                        <img :src="slot.bookingPersons[i].avatarLink">
                      </ion-avatar>
                      <ion-icon v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i" :color="slot.bookingPersons[i].member == 'member' ? 'member' : 'guest'" :md="getGender(slot.bookingPersons[i].gender)" :ios="getGender(slot.bookingPersons[i].gender)"></ion-icon>
                      <ion-button v-else-if="slot.showBookingIcon && selectedTeetime.showAvailableSlots && !slot.isPast" :disabled="!isLoggedIn" fill="clear" @click="doBooking(slot, true)">
                        <ion-icon style="zoom: 1.4" color="successlight" :md="personAddOutline" :ios="personAddOutline"></ion-icon>
                      </ion-button>
                      <ion-icon v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].withDog" :md="pawSharp" :ios="pawSharp" style="zoom: 0.7"></ion-icon>

                      <svg v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].with9Hole" width="22" height="30" style="margin-top: 10px;">
                        <circle cx="10" cy="10" r="10" fill="#eb445a" />
                        <text x="45%" y="35%" text-anchor="middle" fill="white" font-size="12px" font-family="Arial" dy=".3em">9</text>
                      </svg>          

                      <ion-icon v-if="selectedTeetime.showAvailableSlots && !slot.isPast &&  slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].withPlayWithMe" :md="heartOutline" :ios="heartOutline" color="successlight" style="zoom: 0.8"></ion-icon>
                      <ion-icon @click="deleteBooking(slot, i)" v-if="!slot.isPast && isLoggedIn && selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i && slot.bookingPersons[i].canDelete && (slot.bookingPersons[i].isMyBooking || slot.bookingPersons[i].isBookedByMe)" :md="trashOutline" :ios="trashOutline" color="danger" style="zoom: 0.8"></ion-icon>
                      <ion-label v-if="selectedTeetime.showAvailableSlots && !slot.isPast && (slot.bookingPersons.length == 0 || (i+1) > slot.bookingPersons.length)" style="font-size: 14px; vertical-align: middle;">&nbsp;{{ $t('available') }}</ion-label>
                      <ion-label class="ion-text-wrap" v-else-if="selectedTeetime.showBookedSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length - 1 >= i" style="font-size: 14px; vertical-align: middle;">&nbsp;{{ slot.bookingPersons[i].lastName }} {{ slot.bookingPersons[i].firstName }} {{ slot.bookingPersons[i].hcpi }}</ion-label>
                    </ion-item>
                  </div>
                  </ion-list>
                  <br>
                  <ion-progress-bar v-if="selectedTeetime.withSlider && slot.isPast" :value="0"></ion-progress-bar>
                  <ion-progress-bar v-else-if="selectedTeetime.withSlider" :color="getPercentage(slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length, selectedTeetime.maxPersonsBookable, new Date()).color" :value="getPercentage(slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length, selectedTeetime.maxPersonsBookable, new Date()).percentage">3</ion-progress-bar>
                </ion-card-content>
                <ion-card-content v-if="slot.isLocked">
                  <div>
                  <ion-icon style="zoom: 1.5; vertical-align: middle;" color="danger" :md="lockClosedOutline" :ios="lockClosedOutline"></ion-icon>
                  <ion-label style="font-size: 16px; vertical-align: middle;">&nbsp;{{ $t(slot.lockCause) }}</ion-label>
                  </div>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>

<!-- Tagesansicht -->
<div v-if="showDayView" class="day-view-container">
  <div class="day-view-header">
    <div class="time-col">🕒</div>
    <div class="player-col header-col" v-for="n in 4" :key="n">{{ n }}</div>
  </div>

  <div
    v-for="slot in selectedTeetime?.slots"
    :key="slot.date"
    :id="'slot-' + dayjs(slot.date).tz().format('HH-mm')"
    class="day-view-row"
    :class="{ locked: slot.isLocked, past: slot.isPast  }"
    :style="{
      backgroundColor: selectedTeetime.withSlider
        ? getRowColor(slot)
        : 'transparent'
    }"
  >
    <div class="time-col">
      {{ dayjs(slot.date).tz().format('HH:mm') }}
      <p v-if="selectedTeetime.greenfeePaymentEnabled || selectedTeetime.showGreenfeePrice">{{ getPrice(slot) }} </p>
      <span
        v-if="!slot.isPast && slot.carts.filter(f => f.isAvailable).length > 0"
        class="car-icon-inline"
      >
        <ion-icon
          style="zoom: 1.1; vertical-align: middle;"
          color="success"
          :md="carOutline"
          :ios="carOutline"
        ></ion-icon>
      </span>
    </div>

    <!-- Wenn Slot gesperrt ist -->
    <template v-if="slot.isLocked">
      <div class="lock-info" :colspan="selectedTeetime.maxPersonsBookable">
        <ion-icon :icon="lockClosedOutline" color="danger" style="margin-right:6px; zoom:0.8"></ion-icon>
        {{ $t(slot.lockCause) }}
      </div>
    </template>

    <!-- Wenn Slot NICHT gesperrt ist -->
    <template v-else>
      <div
        class="player-col"
        v-for="i in selectedTeetime.maxPersonsBookable"
        :key="i"
      >
        <!-- Spieler -->
        <template v-if="slot.bookingPersons[i - 1]">
          <ion-icon
            v-if="slot.bookingPersons[i - 1].withCart"
            :icon="carOutline"
            color="dangerlight"
            style="zoom:0.8"
          ></ion-icon>
          <span class="player-name">
          <ion-icon
            v-if="!slot.isPast && isLoggedIn && selectedTeetime.showAvailableSlots &&
                   slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i &&
                   slot.bookingPersons[i - 1].canDelete &&
                   (slot.bookingPersons[i - 1].isMyBooking || slot.bookingPersons[i - 1].isBookedByMe)"
            @click="deleteBooking(slot, i - 1)"
            :icon="trashOutline"
            color="danger"
            style="zoom:1.2; margin-left:4px"
          ></ion-icon>
            <ion-icon v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i && slot.bookingPersons[i-1].withCart" :md="carOutline" :ios="carOutline" style="zoom: 1.4" color="dangerlight"></ion-icon>
            <ion-icon style="zoom: 1.4" v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i" :color="slot.bookingPersons[i-1].member == 'member' ? 'member'  : 'guest'" :md="getGender(slot.bookingPersons[i-1].gender)" :ios="getGender(slot.bookingPersons[i-1].gender)"></ion-icon>
            <ion-icon v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i && slot.bookingPersons[i-1].withDog" :md="pawSharp" :ios="pawSharp" style="zoom: 1.4"></ion-icon>

            <svg v-if="selectedTeetime.showAvailableSlots && slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i && slot.bookingPersons[i-1].with9Hole" width="22" height="30" style="margin-top: 0px;">
              <circle cx="10" cy="10" r="10" fill="#eb445a" />
              <text x="45%" y="35%" text-anchor="middle" fill="white" font-size="12px" font-family="Arial" dy=".3em">9</text>
            </svg>          
            <ion-icon v-if="selectedTeetime.showAvailableSlots && !slot.isPast &&  slot.bookingPersons.length != 0 && slot.bookingPersons.length >= i && slot.bookingPersons[i-1].withPlayWithMe" :md="heartOutline" :ios="heartOutline" color="successlight" style="zoom: 1.4"></ion-icon>
            {{ slot.bookingPersons[i - 1].lastName }}
            {{ slot.bookingPersons[i - 1].firstName }}
            {{ slot.bookingPersons[i - 1].hcpi }}
          </span>
        </template>

        <!-- Freier Platz -->
        <template v-if="!slot.bookingPersons[i - 1] && isLoggedIn && !slot.isTeetimeLocked && (slot.showBookingIcon || (!slot.showBookingIcon && !slot.userAllowedToBook && slot.bookingPersons.find(f => f.isMyBooking))) && !slot.isLocked && slot.price >= 0 && !slot.isPast && selectedTeetime.maxPersonsBookable > (slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length)">
          <ion-button class="ion-no-padding ion-no-margin"
            v-if="((selectedTeetime && !selectedTeetime.greenfeePaymentEnabled) || slot.price == 0) && slot.userAllowedToBook"
            size="small"
            fill="clear"
            @click="doBooking(slot, true)"
            :disabled="slot.isLocked || slot.isPast"
          >
            <ion-icon :icon="personAddOutline" color="successlight"></ion-icon>
          </ion-button>
          <ion-button class="ion-no-padding ion-no-margin"
            size="small"
            fill="clear"
            @click="editBooking(slot)"
            :disabled="slot.isLocked || slot.isPast"
          >
            <ion-icon :icon="colorWandOutline" color="primary"></ion-icon>
          </ion-button>
        </template>
      </div>

      <!-- Progressbar unten -->
      <ion-progress-bar
        v-if="selectedTeetime.withSlider"
        class="day-progress-bar"
        :color="getPercentage(
            slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length,
            selectedTeetime.maxPersonsBookable,
            new Date()
          ).color"
        :value="getPercentage(
            slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length,
            selectedTeetime.maxPersonsBookable,
            new Date()
          ).percentage"
      ></ion-progress-bar>
    </template>
  </div>
</div>
    </ion-content>
  </ion-page>
</template>

<script>

import { IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, modalController, toastController, IonIcon,
         IonFab, IonFabButton, IonFabList, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle,
         IonCardTitle, IonLabel, IonChip, IonList, IonItem, IonTabs, IonTabButton, IonTabBar, IonProgressBar,
         IonSelect, IonSelectOption, IonDatetime, alertController, IonToggle, IonAvatar, isPlatform, loadingController,
         IonMenuButton, IonButtons, IonRefresher, IonRefresherContent,
        } from '@ionic/vue';
import { defineComponent, ref, watch, computed, nextTick, onMounted } from 'vue';
import { addOutline, trashOutline, personCircleOutline, personOutline, rocketOutline, optionsOutline,
          chevronBackCircleOutline, personAddOutline, caretDownCircleOutline, swapHorizontalOutline, cartOutline, lockClosedOutline, cameraReverseOutline,
          logoEuro, caretUp, maleOutline, femaleOutline, personSharp, pawSharp, returnUpForwardSharp,
          logInOutline, stopCircleOutline, arrowForwardOutline, arrowBackOutline, todayOutline, timeOutline,
          peopleOutline, openOutline, manSharp, womanSharp, refreshOutline, chevronDownOutline, chevronUpOutline,
          helpCircleOutline, chevronDownCircleOutline, carOutline, checkboxOutline, downloadOutline, golfOutline,
          colorWandOutline, heartOutline, closeOutline } from 'ionicons/icons';
import store from '../main'
import { useQuery, useMutation } from '@vue/apollo-composable'
import * as dayjs from 'dayjs';
require('dayjs/locale/de')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.tz.setDefault('Europe/Paris')
dayjs.locale('de')

import findTeetimeCourseQueryFile from '../graphql/findTeetimeCourse.query.gql'
import getSelectedCourseIDQueryFile from '../graphql/getSelectedCourseID.query.gql'
import lockTeetimeMutationFile from '../graphql/lockTeetime.mutation.gql'
import unlockTeetimeMutationFile from '../graphql/unlockTeetime.mutation.gql'
import createBookingTypeBookingMutationFile from '../graphql/createBookingTypeBooking.mutation.gql'
import deleteBookingTypeBookingMutationFile from '../graphql/deleteBooking.mutation.gql'
import getFlightsByIdQueryFile from '../graphql/getFlightsById.query.gql'
import getFlightPlayersByIdQueryFile from '../graphql/getFlightPlayersById.query.gql'
import HelpCourseDialog from './HelpCourseDialog'
import EditBookingDialog from './dialogs/EditBookingDialog'
import { useRoute, useRouter } from 'vue-router';
import translate from '@/plugins/translate';
import { getClubInfo } from '@/composition'
import Storage from "../plugins/storage.js";

export default defineComponent({
  name: 'Teetime',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonIcon, IonFab, IonFabButton, IonFabList, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader,
    IonCardTitle, IonCardSubtitle, IonLabel, IonChip, IonList, IonItem, IonTabs, IonTabButton, IonTabBar, IonProgressBar,
    IonSelect, IonSelectOption, IonDatetime, alertController, IonToggle, IonAvatar, IonMenuButton, IonButtons,
    IonRefresher, IonRefresherContent,  
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      isLoggedIn : function() { 
        if (this.isLoggedIn != undefined && this.isLoggedIn != this.$store.getters.isLoggedIn) {
          this.findTeetimeCourseRefetch()
          this.getFlightsByIdRefetch()
          this.selectedFlight = 0
        }
        return this.$store.getters.isLoggedIn
      },
  },
  setup() {
    const router = useRouter()
    let dataLoaded = ref(false)
    let forceSpinner = ref(false)
    const route = useRoute()
    let selectedDate = ref(dayjs.tz(new Date()).format('YYYY-MM-DD'))
    if (route.params.date)
      selectedDate = ref(dayjs.tz(new Date(route.params.date)).format('YYYY-MM-DD'))
    const selectedSlot = ref('')
    let bookingOnline = ref(false)
    let selectedNewSlots = ref('0')
    const showAddText = ref(true)
    const imgClass = ref('playerImg')
    const allOpen = ref(!isPlatform('mobile'))
    const clubInfo = ref(getClubInfo())
    const selectedTeetime = ref(null)
    const showDayView = ref(false)
    let loadingSpinner = null
    const customDayShortNames = [
      translate('sunday'),
      translate('monday'),
      translate('tuesday'),
      translate('wednesday'),
      translate('thursday'),
      translate('friday'),
      translate('saturday')
    ];
    const selectedFlight = ref(0)

    const content = ref();
    const contentToScroll = ref(400)
    const currentSlot = ref();

    const { refetch: findTeetimeCourseRefetch, result: findTeetimeCourseResult, loading: findTeetimeCourseLoading, onResult: onFindTeetimeCourseResult } = useQuery(findTeetimeCourseQueryFile, () => ({ id: parseInt(route.params.id),  date: dayjs(selectedDate.value).format('YYYY-MM-DD'), isMobile: isPlatform('mobile'), freeSpots: parseInt(selectedNewSlots.value), minHour: 0, maxHour: 0 }), () => ({ fetchPolicy: 'no-cache', enabled:  route.params.id != null }))

    // TODO: delete – useResult deprecated
    //const selectedTeetime = useResult(findTeetimeCourseResult, null , data => data.findTeetimeCourse.bookingType)
    onFindTeetimeCourseResult(({ data }) => {
      if (data?.findTeetimeCourse) {
        selectedTeetime.value = data.findTeetimeCourse.bookingType
      }
    })
    
    // TODO: delete – useResult deprecated
    //const selectedSelection = useResult(findTeetimeCourseResult, null , data => data.findTeetimeCourse.bookingType.selection.find(f => f.courseid == route.params.id) == null ? data.findTeetimeCourse.bookingType.selection.find(f => f.courseid == (parseInt(route.params.id) > 1 ? (parseInt(route.params.id)-1) : (parseInt(route.params.id)+1))) : data.findTeetimeCourse.bookingType.selection.find(f => f.courseid == route.params.id))
    const selectedSelection = computed(() => {
      const data = findTeetimeCourseResult.value;
      if (!data || !data.findTeetimeCourse || !data.findTeetimeCourse.bookingType) {
        return null;
      }

      const selections = data.findTeetimeCourse.bookingType.selection;
      const courseId = parseInt(route.params.id);

      let match = selections.find(f => f.courseid == courseId);
      if (!match) {
        const fallbackId = courseId > 1 ? courseId - 1 : courseId + 1;
        match = selections.find(f => f.courseid == fallbackId);
      }

      return match || null;
    });

    const { refetch: getSelectedCourseIDRefetch, result: getSelectedCourseIDResult } = useQuery(getSelectedCourseIDQueryFile, () => ({ date: dayjs(selectedDate.value).format('YYYY-MM-DD') }), () => ({ fetchPolicy: 'no-cache', enabled:  route.params.id != null }))

    // TODO: delete – useResult deprecated
    //const selectedCourseID = useResult(findTeetimeCourseResult, null , data => data.getSelectedCourseID.courseID)
    const selectedCourseID = computed(() => {
      const data = findTeetimeCourseResult.value;
      return data?.getSelectedCourseID?.courseID ?? null;
    });


    const { result: getFlightsByIdResult, refetch: getFlightsByIdRefetch } = useQuery(getFlightsByIdQueryFile, () => ({ id: '' }), () => ({ enabled: route.params.id != null, fetchPolicy: 'no-cache'}))


    // TODO: delete – useResult deprecated
    //const flights = useResult(getFlightsByIdResult, null, data => data.getFlightsById.flights)
    const flights = computed(() => {
      const data = getFlightsByIdResult.value;
      return data?.getFlightsById?.flights ?? null; // TODO: if null, Cannot read properties of undefined
    });

    
    const { result: getFlightPlayersByIdResult, refetch: getFlightPlayersByIdRefetch } = useQuery(getFlightPlayersByIdQueryFile, () => ({ id: selectedFlight.value, bookingTypeId: parseInt(route.params.id), slotDate: route.params.date, checkPayment: true }) , () => ({ enabled: route.params.id != null && route.params.date != null, fetchPolicy: 'no-cache' }))

    // TODO: delete – useResult deprecated
    //const flightPlayers = useResult(getFlightPlayersByIdResult, null, data => data.getFlightPlayersById.flightPlayers)
    const flightPlayers = computed(() => {
      const data = getFlightPlayersByIdResult.value;
      return data?.getFlightPlayersById?.flightPlayers ?? null;
    });

    
    const { mutate: createBookingTypeBookingMutation } = useMutation(createBookingTypeBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: deleteBookingTypeBookingMutation } = useMutation(deleteBookingTypeBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: lockTeetimeMutation } = useMutation(lockTeetimeMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: unlockTeetimeMutation } = useMutation(unlockTeetimeMutationFile, { fetchPolicy: 'no-cache' });

    watch(showDayView, async (val) => {
      if (val) {
        await nextTick()
        scrollToCurrentTime()
      }
    })

    watch(
      () => route.params.date,
      (date, prevId) => {
        if (route.path.startsWith('/teetime/') && date != undefined)
          selectedDate.value = dayjs.tz(new Date(route.params.date)).format('YYYY-MM-DD')
          forceSpinner.value = true
      }
    )

    watch(selectedSelection, async (newLoading, prevLoading)=> {
      if (newLoading && newLoading.courseid && newLoading.courseid != route.params.id)
        router.push('/teetime/' + newLoading.courseid + '/' + route.params.date)
    })

    loadingController.create().then(res => {
      loadingSpinner = res
      loadingSpinner.present().then(async ()  => { 
        if (!findTeetimeCourseLoading.value && loadingSpinner != null) {
          loadingSpinner.dismiss() 
          loadingSpinner = null
          if (!dataLoaded.value)
            setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
          dataLoaded.value = true
          forceSpinner.value = false
        }
      })
    }).catch(err => { })

    watch(findTeetimeCourseLoading, async (newLoading, prevLoading)=> {
      if (!newLoading && loadingSpinner != null) {
          loadingSpinner.dismiss()
          loadingSpinner = null
          if (!dataLoaded.value) {
            setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
          }
          dataLoaded.value = true
          forceSpinner.value = false
          return
      }
      else if (newLoading && (!dataLoaded.value || forceSpinner.value)) {
        loadingController.create().then(res => {
              showAddText.value = true
              loadingSpinner = res
              loadingSpinner.present().then(async () => { 
                if (!findTeetimeCourseLoading.value) {
                  if (loadingSpinner)
                    loadingSpinner.dismiss() 
                  loadingSpinner = null
                  if (!dataLoaded.value)
                    setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
                  dataLoaded.value = true
                  forceSpinner.value = false
                }
              })
            }).catch(err => { })
      }
    })

    function scrollToCurrentTime() {
      const now = dayjs()
      const currentMinutes = now.hour() * 60 + now.minute()

      // alle Slot-Elemente im DOM holen
      const slotElements = document.querySelectorAll('.day-view-row[id^="slot-"]')
      if (!slotElements.length) return

      let closestElem = null
      let closestDiff = Infinity

      slotElements.forEach((el) => {
        const id = el.id.replace('slot-', '') // z. B. "09-30"
        const [hour, minute] = id.split('-').map(Number)
        const slotMinutes = hour * 60 + minute
        const diff = Math.abs(currentMinutes - slotMinutes)

        if (diff < closestDiff) {
          closestDiff = diff
          closestElem = el
        }
      })

      if (closestElem) {
        closestElem.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }

    onMounted(async () => {
      const savedView = await Storage.getItem('showDayView')
      if (savedView !== null) {
        showDayView.value = savedView === 'true'
      }
    })

    // Speichern, wenn sich der Zustand ändert
    watch(showDayView, async (newValue) => {
      await Storage.setItem('showDayView', newValue)
    })
    
    //TODO: entferne, just for testing
    setTimeout(() => {
      
    
      
      
    }, 8000); // nach 8 Sekunden

    return {
      createBookingTypeBookingMutation, deleteBookingTypeBookingMutation, getFlightsByIdResult,
      findTeetimeCourseRefetch, findTeetimeCourseResult,
      personCircleOutline, chevronBackCircleOutline, trashOutline, personAddOutline, caretDownCircleOutline,
      swapHorizontalOutline, addOutline, cartOutline, logoEuro, lockClosedOutline, findTeetimeCourseLoading, selectedDate,
      personOutline, rocketOutline, optionsOutline, caretUp, helpCircleOutline,
      bookingOnline, maleOutline, femaleOutline, personSharp, pawSharp, returnUpForwardSharp,
      logInOutline, stopCircleOutline, arrowForwardOutline, arrowBackOutline,todayOutline,
      selectedNewSlots, loadingSpinner, route, timeOutline,  dayjs, selectedSlot, heartOutline,
      customDayShortNames, content, contentToScroll, currentSlot, peopleOutline, openOutline,
      scrollToBottom: () => content.value.$el.scrollToBottom(500), flights, selectedFlight, manSharp, womanSharp,
      refreshOutline, chevronDownCircleOutline, isPlatform, lockTeetimeMutation, unlockTeetimeMutation, showAddText,
      carOutline, checkboxOutline, downloadOutline, forceSpinner, flightPlayers, getFlightPlayersByIdRefetch, closeOutline, imgClass, allOpen, showDayView, cameraReverseOutline,
      getFlightsByIdRefetch, selectedTeetime, chevronDownOutline, chevronUpOutline, dataLoaded, selectedSelection, golfOutline, colorWandOutline, clubInfo, getSelectedCourseIDRefetch, selectedCourseID
    }
  },
  methods: {
   getRowColor(slot) {
      const p = this.getPercentage(
        slot.bookingPersons.length == 0 ? 0 : slot.bookingPersons.length,
        this.selectedTeetime.maxPersonsBookable,
        new Date()
      ).color

      switch (p) {
        case 'successlight': return 'rgba(76, 175, 80, 0.1)'   // grünlich
        case 'warning': return 'rgba(255, 193, 7, 0.15)'       // gelblich
        case 'dangerlight': return 'rgba(244, 67, 54, 0.12)'   // rötlich
        case 'danger': return 'rgba(244, 67, 54, 0.2)'         // stark rot
        default: return 'transparent'
      }
    },
    onSwipeRight() {
      this.goDateBack()
	  },
    onSwipeLeft() {
      this.goDateForward()
	  },
    openAll(value) {
      for (const slot of this.selectedTeetime.slots) {
        slot.showPlayers = value
      }
      this.allOpen = value
    },
    changeImg() {
      if (this.imgClass == 'playerImg')
        this.imgClass = 'playerImgBig'
      else
        this.imgClass = 'playerImg'
    },
    closeDialog(value) {
      this.showAddText = value
    },
    getGender(gender) {
      if (gender == "")
        return this.personOutline
      else if (gender == "male")
        return this.manSharp
      else
        return this.womanSharp
    },
    async doRefresh(event) {
      event.target.complete();
      await this.findTeetimeCourseRefetch()
    },
    itemChanged(value) {
      if (value != undefined && value != this.selectedSelection.courseid) {
        this.forceSpinner = true
        this.dataLoaded = false
        this.$router.push('/teetime/' + value + '/' + dayjs.tz(this.selectedDate).format('YYYY-MM-DD'))
      }
    },
    refresh() {
      this.forceSpinner = true
      this.findTeetimeCourseRefetch()
    },
    async deleteBooking(slot, pos) {
      const alert = await alertController.create({
        header: 'Booking',
        message: this.$t('delete') + ': ' + dayjs(slot.date).tz().format('DD.MM.YYYY HH:mm') + '?',
        buttons: [
          {
            text: this.$t('cancel'),
            role: 'cancel',
            cssClass: 'secondary'
          },
          {
            text: this.$t('ok'),
            handler: async () => {
              this.deleteBookingTypeBookingMutation({
                dateSlot: slot.date,
                position: slot.bookingPersons[pos].uniqueId,
                bookingTypeId: this.$route.params.id,
                language: this.$store.getters.language
              })
              .then(res => {
                this.findTeetimeCourseRefetch();
                toastController.create({
                  message: this.$t('bookingDeleted'),
                  duration: 3000,
                  color: 'warning'
                }).then(t => t.present());
              })
              .catch(err => {
                toastController.create({
                  message: this.$t('notSuccessful') + ': ' + err,
                  duration: 3000,
                  color: 'danger'
                }).then(t => t.present());
              });
            }
          }
        ]
      });

      return alert.present();
    },
      
    async openCourseHelp() {
      const modal = await modalController
        .create({
          component: HelpCourseDialog,
          componentProps: {
            propsData: {
              selectedTeetimeId: this.$route.params.id,
              selectedDate: this.selectedDate,
            }
          },
        })
      return modal.present();
    },
    setId(slot) {
      if(slot.currentSlot) {
        return "currentSlot"
      }
    },
    setFreeSpots() {
      this.forceSpinner = true
    },
    goDateToday() {
      this.forceSpinner = true
      this.getSelectedCourseIDRefetch( { date: dayjs.tz(new Date()).format('YYYY-MM-DD') })
      .then(res => {
        const courseID = res.data.getSelectedCourseID.courseID == 0 ?  this.$route.params.id : res.data.getSelectedCourseID.courseID
        this.$router.push('/teetime/' + courseID + '/' + dayjs.tz(new Date()).format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(new Date()).format('YYYY-MM-DD')
      })
      .catch(err => {
        this.$router.push('/teetime/' + this.$route.params.id + '/' + dayjs.tz(new Date()).format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(new Date()).format('YYYY-MM-DD')
      }) 
    },
    goDateBack() {
      this.forceSpinner = true
      this.getSelectedCourseIDRefetch( { date: dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD') })
      .then(res => {
        const courseID = res.data.getSelectedCourseID.courseID == 0 ?  this.$route.params.id : res.data.getSelectedCourseID.courseID
        this.$router.push('/teetime/' + courseID + '/' + dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD')
      })
      .catch(err => {
        this.$router.push('/teetime/' + this.$route.params.id + '/' + dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD')
      }) 
    },
    goDateForward() {
      this.forceSpinner = true
      this.getSelectedCourseIDRefetch( { date: dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD') })
      .then(res => {
        const courseID = res.data.getSelectedCourseID.courseID == 0 ?  this.$route.params.id : res.data.getSelectedCourseID.courseID
        this.$router.push('/teetime/' + courseID + '/' + dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD')
      })
      .catch(err => {
        this.$router.push('/teetime/' + this.$route.params.id + '/' + dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD'))
        this.selectedDate = dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD')
      }) 
    },
    getBookingColor(slot, key) {
      if (slot.isPast)
        return ""
      if (!slot.isPast && slot.bookingPersons.length > 0 && slot.bookingPersons.length - 1 >= key && slot.bookingPersons[key].isMyBooking)
        return "success"
      return ""
    },
    async editBooking(slot, doRefetch = true) {
      //this.selectedSlot = slot.date
      await this.getFlightPlayersByIdRefetch({ id: this.selectedFlight, bookingTypeId: parseInt(this.$route.params.id), slotDate: slot.date, checkPayment: true } )

      if (!this.flightPlayers || (this.flightPlayers && this.flightPlayers.length <= 0 )) {
          toastController
            .create({
              message: this.$t('noPlayers'),
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
          return;
      }

      let pricesum = parseFloat(slot.price)
      if (this.flightPlayers) {
        pricesum = this.flightPlayers.map(p => p.price).reduce((price, p) => p + price)
      }

      let play18Holes = true
      if (this.clubInfo.clubInfo.askTeetimeNumHoles == true) {
        const confirmation = await this.warn()
        if (!confirmation) play18Holes = false
        for (const player of this.flightPlayers) {
          player.show9Hole = !confirmation
        }

      }

      this.lockTeetimeMutation({ dateSlot: slot.date, bookingTypeId: this.$route.params.id})
      .then(async res  => {
        if (res.data.lockTeetime.success) {
          const modal = await modalController
            .create({
              component: EditBookingDialog,
              cssClass: this.isPlatform('mobile') ? '' : 'editBooking-modal',
              breakpoints: [1],
              initialBreakpoint: 1,
              backdropBreakpoint: 1,
              componentProps: {
                propsData: {
                  slot: slot,
                  bookingTypeId: this.$route.params.id,
                  flightPlayers: this.flightPlayers,
                  selectedTeetime: this.selectedTeetime,
                  play18Holes: play18Holes
                }
              },
            })
          modal.onDidDismiss()
            .then((data) => {
              this.getFlightPlayersByIdRefetch()
              if (data.data) {
                  this.findTeetimeCourseRefetch()
              }
              else
                this.unlockTeetimeMutation({ dateSlot: slot.date, bookingTypeId: this.$route.params.id})
            })

          return modal.present();
        }
      })
      .catch(err => {
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 

    },
    async warn() {
      return new Promise(async (resolve) => {
        const confirm = await alertController.create({
          header: translate('ask9holes'),
          message: translate('ask9holesText'),
          cssClass: 'custom-alert',
          buttons: [
            {
              text: translate('9holes'),
              handler: () => {
                return resolve(false);
              },
            },
            {
              text: translate('18holes'),
              handler: () => {
                return resolve(true);
              },
            },
            {
              text: this.$t('cancel') ,
              role: 'cancel',
            },
          ],
        });

        await confirm.present();
    });
    },
    async doBooking(slot, justMe = false) {

      if (!this.flightPlayers || (this.flightPlayers && this.flightPlayers.length <= 0 )) {
          toastController
            .create({
              message: this.$t('noPlayers'),
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
          return;
      }

      // get price for all players
      if (this.selectedTeetime.greenfeePaymentEnabled) {
        let pricesum = parseFloat(slot.price)
        if (this.flightPlayers) {
          await this.getFlightPlayersByIdRefetch({ id: this.selectedFlight, bookingTypeId: parseInt(this.$route.params.id), slotDate: slot.date } )
          const filteredPlayers = this.flightPlayers.filter(f => f.payGreenfee)
          if (filteredPlayers && filteredPlayers.length > 0) 
            pricesum = this.flightPlayers.map(p => p.price).reduce((price, p) => p + price)
        }

        if ((justMe && parseFloat(slot.price) > 0) || pricesum > 0) {
          this.editBooking(slot, false)
          return
        }
      }
      let slotJson = slot
      let players = JSON.stringify(this.selectedFlight)
      if (justMe ) //TODO: && this.flights != null
        players = JSON.stringify(this.flights[0].id)

      let play18Holes = true
      if (this.clubInfo.clubInfo.askTeetimeNumHoles == true) {
        const confirmation = await this.warn()
        if (!confirmation) play18Holes = false
      }

      this.createBookingTypeBookingMutation({ dateSlot: slotJson.date, bookingTypeId: this.$route.params.id, players: players, useFlightIds: true, language: this.$store.getters.language, play18Holes: play18Holes })
      .then(res => {
          this.findTeetimeCourseRefetch()
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
      })
      .catch(err => {
          /*toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())*/
      }) 

    },

    getPrice(slot) {
      let slotJson = slot
      if (slotJson.isLocked || slotJson.isPast)
        return ''
      else
        return slotJson.price + " " + slotJson.currencySymbol
    },
    goBack() {
      this.$router.go(-1)
    },
    getPercentage (bookedPlayers, maxPlayers, datetime) {
      const percentage = (bookedPlayers / maxPlayers) == 0 ? 1: bookedPlayers / maxPlayers
      let color = "successlight"
      if (bookedPlayers == maxPlayers)
        color = "danger"
      else if (percentage > 0 && percentage <= 0.25)
        color = "warninglight"
      else if (percentage > 0.25 && percentage <= 0.5)
        color = "warning"
      else if (percentage > 0.5 && percentage <= 0.75)
        color = "dangerlight"
      else if (percentage > 0.75 && bookedPlayers != 0)
        color = "danger"

      return { percentage: percentage, color: color }
    },
  }
});

</script>

<style scoped>

.time-col p {
  margin: 0;              /* entfernt Standardabstände */
  padding: 0;
  line-height: 1.1;       /* engerer Textabstand */
}

.time-col ion-icon {
  margin-top: 2px;        /* leicht anheben */
  display: inline-block;
}

.car-icon-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 6px; /* etwas Abstand nach der Uhrzeit oder dem Preis */
}

/* Vergangene Zeilen grau einfärben */
.day-view-row.past {
  background-color: #f4f4f4 !important; /* sanftes Grau */
  opacity: 0.8;
}

/* Optional: Text leicht ausgrauen */
.day-view-row.past .time-col,
.day-view-row.past .player-name,
.day-view-row.past ion-icon {
  color: #666 !important;
  filter: grayscale(60%);
}

.header-col {
  display: flex;
  justify-content: center !important;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

.small-daycomment-row {
  margin: 0;
  padding: 2px 0 0 0; /* weniger vertikaler Abstand */
}

.small-daycomment {
  display: block;
  margin-left: 12px;
  font-size: 14px;          /* kleinerer Text */
  line-height: 1.0;         /* kompakter Zeilenabstand */
  color: var(--ion-color-medium, #666); /* dezente Farbe */
  white-space: pre-wrap;    /* Zeilenumbrüche im Text erhalten */
  word-wrap: break-word;    /* bricht lange Worte */
}

.small-datetime {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 4px;
  --padding-end: 4px;
  --min-height: 28px;       /* kompaktere Höhe */
  font-size: 14px;          /* kleinere Schrift */
  --color: var(--ion-text-color, #222);
}

.small-datetime::part(text) {
  font-size: 14px;          /* Textgröße im sichtbaren Bereich */
}

/* Optional: damit es perfekt zur Toolbar passt */
.small-datetime {
  --background: transparent;
  --border-color: transparent;
}

.small-select {
  --padding-top: 2px;
  --padding-bottom: 2px;
  --padding-start: 4px;
  --padding-end: 4px;
  --min-height: 28px;     /* kleiner als Standard (ca. 40px) */
  font-size: 14px;        /* kleinere Schrift */
  --color: var(--ion-text-color, #222);
}

.small-select::part(text) {
  font-size: 14px;        /* Schriftgröße im sichtbaren Bereich */
}

/* Optional: kleinere Optionen im Dropdown */
ion-select-option {
  font-size: 13px;
}

.day-view-row {
  display: grid;
  grid-template-columns: 70px repeat(4, 1fr);
  align-items: start;
  position: relative;
  padding: 4px 0;
  position: relative;
}

.day-view-row::after {
  /* 👇 Untere Linie für ALLE Zeilen, unabhängig vom Inhalt */
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(0, 0, 0, 0.15);
}

.lock-info {
  grid-column: 2 / span 4; /* 👈 nimmt alle 4 Spieler-Spalten ein */
  text-align: center;
  color: var(--ion-color-danger, #eb445a);
  font-weight: bold;
  background: rgba(255, 0, 0, 0.05);
  padding: 6px 0;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compact-toggle {
  --min-height: 32px;
  --inner-padding-top: 0;
  --inner-padding-bottom: 0;
  --padding-start: 8px;
  --padding-end: 8px;
  font-size: 13px;
}

.tiny-toggle {
  transform: scale(0.5);
  transform-origin: right center;
}

.day-view-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;
}

.day-view-header,
.day-view-row {
  display: grid;
  grid-template-columns: 70px repeat(4, 1fr);
  align-items: center;
  text-align: center;
  border-bottom: 1px solid var(--ion-color-light);
  
}

.day-view-header {
  background-color: var(--ion-color-light);
  font-weight: bold;
  background: linear-gradient(to bottom, #e0e0e0, #d5d5d5); /* sanfter Verlauf */
  color: #222;
}

.time-col {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  padding-right: 5px;
}

/* Freie Slots → Icons nebeneinander */
.player-col:has(ion-button) {
  flex-direction: row;           /* 👈 horizontal anordnen */
  justify-content: center;       /* zentriert nebeneinander */
  align-items: center;
  gap: 6px;                      /* kleiner Abstand */
}

.player-col {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start; /* 👈 sorgt dafür, dass Spieler oben ausgerichtet sind */
  padding: 2px 4px;
  min-height: 40px;         /* sorgt für gleichmäßige Zeilenhöhe */
  gap: 2px;                 /* etwas Abstand zwischen Icons, Namen etc. */
  height: 100%; /* 👈 zwingt Flex-Container, volle Höhe der Zeile einzunehmen */
  text-align: left; 
}

.day-view-row.locked {
  background-color: rgba(255, 200, 200, 0.3);
}

.player-name {
  display: block;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: left;
  font-size: 13px;
  line-height: 1.3;
}

.playerImg {
  width: 40px; 
  height: 40px;
}

.playerImgBig {
  width: 120px; 
  height:120px
}

#container {
  text-align: center;
  
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

section {
  margin-top: 1em;
  margin-bottom: 2.5em;
}

section:not(.full-width),
.full-width > header {
  padding: 0 10px;
}

.item .item-content {
  background-color: green !important;
}

.itemFlight {
    --background-hover: unset;
}

ion-icon:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
}

.buttonNoPadding {
  --padding-end: 0px;
  --inner-padding-end: 0px;
  margin-inline: 0px 15px;
}

</style>

<style lang="scss">
.card-center {
    width:90%; // adjust width on your ion-card suitable on your screen
    display:block;
    margin: 0 auto;
}

.custom-alert button.alert-button-group {
    width: 33.33%;
}

.custom-alert .alert-button-group .button-inner {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.custom-alert .alert-button-group-vertical {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row ;
}
//.alert-wrapper {
//width: 100% !important;
//max-width: 100% !important;
//}

</style>